/**
 * A product's `repositories` column predates the picker by two years and holds free text: an
 * `owner/name`, a full URL, sometimes a `.git` suffix. The picker's options are keyed by `owner/name`,
 * so a stored URL matches nothing and an existing link reads as unlinked. Normalising on the way into
 * the draft also means saving rewrites the old shape, which the API already accepts either way.
 *
 * Anything it cannot recognise is returned cleaned rather than dropped: a value it doesn't understand
 * is still a link somebody made.
 */
export const toRepositoryFullName = (repository: string): string =>
  repository
    .trim()
    .replace(/^https?:\/\/(www\.)?github\.com\//i, '')
    .replace(/\.git$/i, '')
    .replace(/^\/+|\/+$/g, '');
